import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import cardClient from '../../client/CardClient';
import { Pagination, Spin, Row } from 'antd';
import CardInfoCard from "../CardInfoCard/CardInfoCard";
import usePagedList from '../../hooks/usePagedList';
import useIsMobile from '../../hooks/useIsMobile';

// Модульная функция: стабильная ссылка для эффекта загрузки в usePagedList
const fetchCardsPage = (deckId, pageIndex, pageSize) =>
    cardClient.getCardsByDeckId(deckId, { page: pageIndex, size: pageSize });

const CardList = () => {
    const { t } = useTranslation();
    const {
        selectedDeck, items: cards, loading, total, currentPage, pageSize, setPage, updateItem, removeItem,
    } = usePagedList(fetchCardsPage, t('list.loadCardsFailed'));
    const isMobile = useIsMobile();

    if (!selectedDeck) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{t('list.selectDeckForCards')}</p>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', padding: '0px' }}>
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin tip={t('list.loadingCards')} size="large" />
                </div>
            ) : (
                <>
                    {cards && cards.length > 0 ? (
                        cards.map((card) => (
                            <CardInfoCard
                                key={card.id}
                                card={card}
                                onUpdateCard={updateItem}
                                onDeleteCard={removeItem}
                            />
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <p>{t('list.noCards')}</p>
                        </div>
                    )}
                    {total > pageSize && (
                        <Row justify="center" style={{ marginTop: '20px' }}>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={total}
                                onChange={setPage}
                                simple={isMobile}
                                size={isMobile ? 'small' : 'default'}
                            />
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default CardList;
